"use strict";

exports.__esModule = true;
exports.legendFontSize = void 0;
exports.legendStyle = legendStyle;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Props for a Recharts <Legend>: under the modern UI a small swatch of the
 * given shape and muted text, otherwise exactly what the chart passed before
 * (`legacy`). Recharts only recognises <Legend> as a direct child, so this is
 * a prop bag rather than a component.
 */
function legendStyle(theme, _ref, legacy) {
  var iconType = _ref.iconType,
    iconSize = _ref.iconSize;
  if (legacy === void 0) {
    legacy = {};
  }
  if (!theme || !theme.uiModern) {
    return legacy;
  }
  return {
    iconType: iconType,
    iconSize: iconSize,
    formatter: function formatter(value) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          color: theme.ChartLegendTextColor
        }
      }, value);
    }
  };
}

/** Legend text size: 11px in the modern UI, the theme's XS size before. */
var legendFontSize = exports.legendFontSize = function legendFontSize(theme) {
  return theme && theme.uiModern ? 11 : theme.fontSizeXS;
};